(function() {
  const THRESHOLD = 0.3;
  const ROOT_MARGIN = '50px 0px';
  
  const loadedVideos = new Set();
  let observer = null;
  
  function hasLoadedSources(video) {
    if (!video) return false;
    const sources = video.querySelectorAll('source');
    return Array.from(sources).some(source => source.hasAttribute('src'));
  }
  
  function loadVideo(container) {
    try {
      const videoId = container.dataset.videoId;
      if (!videoId) return;
      
      if (loadedVideos.has(videoId)) return;
      
      const video = container.querySelector(`#${videoId}`) || 
                    container.querySelector('video');
      
      if (!video) return;
      
      if (hasLoadedSources(video)) {
        loadedVideos.add(videoId);
        return;
      }
      
      const sources = video.querySelectorAll('source[data-src]');
      if (!sources.length) return;
      
      let updated = false;
      sources.forEach(source => {
        const src = source.getAttribute('data-src');
        if (src) {
          source.setAttribute('src', src);
          updated = true;
        }
      });
      
      if (updated) {
        loadedVideos.add(videoId);
        video.load();
        
        if (video.dataset.autoplay === 'true') {
          try {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
          } catch (playError) {
            // Silently handle play errors
          }
        }
      }
    } catch (error) {
      // Silently handle errors
    }
  }
  
  function setupObserver() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.lazy-video-container').forEach(loadVideo);
      return;
    }
    
    try {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: THRESHOLD,
        rootMargin: ROOT_MARGIN
      });
      
      observeAllVideos();
    } catch (error) {
      // Fallback - load all videos
      document.querySelectorAll('.lazy-video-container').forEach(loadVideo);
    }
  }
  
  function observeAllVideos() {
    if (!observer) return;
    
    const containers = document.querySelectorAll('.lazy-video-container');
    containers.forEach(container => {
      const videoId = container.dataset.videoId;
      if (videoId && !loadedVideos.has(videoId)) {
        observer.observe(container);
      }
    });
  }
  
  function initialize() {
    setupObserver();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Public API
  window.lazyVideos = {
    load: loadVideo,
    loadAll: function() {
      document.querySelectorAll('.lazy-video-container').forEach(loadVideo);
    },
    refresh: observeAllVideos
  };
})(); 